import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import './BusinessOntologyPage.css';

// The ontology is a self-contained HTML document (its own tabs, search and
// theme toggle), so it renders as-is in a frame rather than being ported.
// No allow-same-origin: its scripts run in an opaque origin and cannot read
// Nexus cookies, storage or this page. Its storage calls are all try/caught,
// so they degrade to "remember nothing" instead of breaking.
const SANDBOX = 'allow-scripts allow-popups allow-popups-to-escape-sandbox';

// Outbound source links would otherwise navigate the frame away from the
// document; send them to a new tab instead.
export function prepareOntologyDoc(html) {
  return html.replace('<head>', '<head><base target="_blank">');
}

export default function BusinessOntologyPage() {
  const [state, setState] = useState({ status: 'loading', doc: null });

  const load = useCallback(() => {
    setState({ status: 'loading', doc: null });
    axios.get(`${API_BASE_URL}/api/business-ontology`, { withCredentials: true })
      .then((r) => {
        const html = r.data && r.data.html;
        if (!html) throw new Error('empty');
        setState({ status: 'ready', doc: prepareOntologyDoc(html) });
      })
      .catch(() => setState({ status: 'error', doc: null }));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (state.status === 'loading') {
    return (
      <div className="bo-state" aria-busy="true" aria-label="Loading the Business Ontology">
        <div className="spinner" />
      </div>
    );
  }

  if (state.status === 'error') {
    return (
      <div className="bo-state" role="alert">
        <p className="bo-state-title">Couldn't load the Business Ontology.</p>
        <p className="bo-state-help">Check your connection and try again.</p>
        <button type="button" className="btn btn-primary" onClick={load}>Try again</button>
      </div>
    );
  }

  return (
    <div className="bo-root">
      <iframe
        className="bo-frame"
        title="RTG Business Ontology"
        sandbox={SANDBOX}
        srcDoc={state.doc}
      />
    </div>
  );
}
